<template>
  <AddOption type="edit" :edit="editData" @resetEdit="resetEdit" />
</template>

<script>
import AddOption from "./AddOption.vue";
import { mapState, mapGetters } from "vuex";
export default {
  name: "EditOption",
  components: { AddOption },
  props: {
    value: {
      required: true
    }
  },
  data: () => ({
    editData: {}
  }),
  methods: {
    resetEdit() {
      this.$set(this, "editData", {});
    },
    closeDialog() {
      this.resetOptionData = true;
      this.dialog = false;
    }
  },
  computed: {
    ...mapState({
      activeOption: state => state.Option.option,
      activeoptionType: state => state.Option.optionType,
    }),
    ...mapGetters({
      optionStore: "Option/optionStore"
    })
  },
  watch: {
    value(optionCode) {
      if (optionCode) {
        const { optionName, optionType } = this.activeoptionType;
        this.$store
          .dispatch(this.optionStore("option_l"), {
            optionCode,
            optionName,
            optionType
          })
          .then(res => {
            if (res.status === 200) {
              this.$set(this, "editData", res.data);
              this.$emit("input", "");
            } else {
              this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
            }
          });
      }
    }
  }
};
</script>

<style>
</style>